import { Styles } from 'react-jss'

export const sheet: Styles = {
  '@global': {
    html: { scrollBehavior: 'smooth' }
  },

  stickyBar: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 5,
    backdropFilter: 'saturate(180%) blur(8px)',
    background: 'rgba(255, 255, 255, 0.95)',
    borderBottom: '1px solid rgba(128,128,128,0.12)'
  },
  stickyBarOpen: {
    background: 'rgba(255, 255, 255, 0.95)',
    boxShadow: '0 2px 24px rgba(0,0,0,0.35)'
  },

  stickyInner: {
    height: 72,
    display: 'grid',
    gridTemplateColumns: 'auto 1fr auto',
    alignItems: 'center',
    gap: '16px',
    margin: '0 auto',
    padding: '0 16px'
  },

  headerLogo: {
    justifySelf: 'start',
    alignSelf: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0px',
    zIndex: 1,
    '& > span': {
      fontSize: 36,
      lineHeight: '36px',
      fontWeight: 400,
      letterSpacing: '0.02em',
      color: '#080910',
      whiteSpace: 'nowrap'
    }
  },

  headerNav: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 auto',
    maxWidth: 1200,
    // gap: '12px',
    '& > a': {
      padding: '10px 0',
      margin: '0 20px'
    }
  },

  headerAuth: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '0 16px'
  },

  menuIcons: {
    display: 'none'
  },

  '@media (max-width: 992px)': {
    stickyInner: {
      // gridTemplateColumns: '120px auto 40px', // logo | nothing | burger
      height: 64
    },
    headerNav: {
      display: 'none',
      position: 'fixed',
      top: 64,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.99)',
      padding: 16,
      flexDirection: 'column',
      gap: '8px',
      borderBottom: '1px solid rgba(0,0,0,0.12)',
      zIndex: 5,

      '&.showMenu': {
        display: 'flex',
        '& > a': { margin: '0 auto' }
      }
    },

    headerTitle: {
      height: 'calc(93vh - 64px)'
    },
    headerAuth: {
      display: 'none'
    },
    menuIcons: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  }
}
